<div class="tp-page tp-page--narrow">
  <tp-page-header title="Cuenta en revisión"></tp-page-header>
  <section class="tp-card">
    <tp-empty-state
      icon="hourglass_top"
      title="Sus datos se encuentran bajo revisión"
      message="Al finalizar el proceso será notificado."
    >
      <button action mat-flat-button type="button" class="no-role__exit" (click)="logout()">Salir</button>
    </tp-empty-state>
  </section>
</div>
